import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class FileIntegrationStateService {
	private fileStateSubject = new BehaviorSubject<string | null>(null);
	fileState$ = this.fileStateSubject.asObservable();

	setFileState(state: string) {
		this.fileStateSubject.next(state);
	}

	clearFileState() {
		this.fileStateSubject.next(null);
	}
}
